export { default as default } from './VideoBasic';
